export interface Category {
  id: string;
  name: string;
  slug: string;
}

export interface Post {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  image: string;
  imageAlt: string;
  metaTitle: string;
  metaDescription: string;
  keywords: string;
  mainKeyword: string;
  status: 'published' | 'draft';
  readTime: number;
  views: number;
  autoLinkEnabled: boolean;
  autoLinkLimit: number;
  authorName: string;
  whatsappCTA: boolean;
  createdAt: string;
  updatedAt: string;
}

export const categories: Category[] = [
  { id: 'cat-1', name: 'Cerca Elétrica', slug: 'cerca-eletrica' },
  { id: 'cat-2', name: 'Câmeras de Segurança', slug: 'cameras-de-seguranca' },
  { id: 'cat-3', name: 'Portão Eletrônico', slug: 'portao-eletronico' },
  { id: 'cat-4', name: 'Alarme Residencial', slug: 'alarme-residencial' },
  { id: 'cat-5', name: 'Segurança Rural', slug: 'seguranca-rural' },
];

export const posts: Post[] = [
  {
    id: 'post-1',
    title: 'Como Escolher a Melhor Cerca Elétrica para sua Propriedade',
    slug: 'como-escolher-melhor-cerca-eletrica',
    excerpt: 'Guia completo para escolher a cerca elétrica ideal para sua propriedade. Conheça os tipos, vantagens e dicas de instalação.',
    content: `
      <p>A <strong>cerca elétrica</strong> é uma das soluções mais eficazes de proteção perimetral disponíveis no mercado de <strong>segurança eletrônica</strong>. Seja para residências, comércios ou propriedades rurais, a escolha correta do equipamento faz toda a diferença na eficácia da proteção.</p>
      <h2>Por que investir em cerca elétrica?</h2>
      <p>A principal vantagem da <strong>cerca elétrica</strong> é a <strong>dissuasão preventiva</strong>. Estudos mostram que 90% das tentativas de invasão são abortadas ao perceber a existência de uma cerca energizada. Além disso, o custo-benefício é excelente quando comparado a outras soluções de segurança.</p>
      <h2>Tipos de cerca elétrica</h2>
      <p>Existem diferentes modelos no mercado:</p>
      <ul>
        <li><strong>Cerca elétrica residencial</strong> – ideal para casas e pequenos comércios, com voltagem controlada</li>
        <li><strong>Cerca elétrica industrial</strong> – alta tensão para grandes perímetros</li>
        <li><strong>Cerca elétrica rural</strong> – projetada para longas distâncias e condições climáticas adversas</li>
      </ul>
      <h2>O que avaliar antes da compra?</h2>
      <p>Considere o <strong>comprimento do perímetro</strong>, o tipo de <strong>energizador</strong> necessário, a <strong>qualidade dos fios</strong> e a <strong>assistência técnica</strong> da empresa instaladora. A Eletrônica 2000 oferece projetos personalizados com garantia completa.</p>
      <h2>Manutenção preventiva</h2>
      <p>Para garantir o funcionamento contínuo, faça inspeções mensais dos isoladores, verifique o estado dos fios e teste o energizador regularmente. A manutenção preventiva evita falhas no momento mais crítico.</p>
    `,
    categoryId: 'cat-1',
    image: '/imagem/cerca-eletrica.webp',
    imageAlt: '',
    metaTitle: 'Como Escolher a Melhor Cerca Elétrica | Eletrônica 2000',
    metaDescription: 'Guia completo para escolher a cerca elétrica ideal. Conheça os tipos, vantagens e dicas de instalação com a Eletrônica 2000.',
    keywords: 'cerca elétrica, segurança eletrônica, proteção perimetral, alarme',
    mainKeyword: '',
    status: 'published',
    readTime: 6,
    views: 0,
    autoLinkEnabled: true,
    autoLinkLimit: 2,
    authorName: 'Equipe Eletrônica 2000',
    whatsappCTA: false,
    createdAt: '2025-04-15T10:00:00Z',
    updatedAt: '2025-04-15T10:00:00Z',
  },
  {
    id: 'post-2',
    title: 'Câmeras de Segurança: IP ou Analógica? Descubra a Melhor Opção',
    slug: 'cameras-seguranca-ip-ou-analogica',
    excerpt: 'Compare câmeras IP e analógicas para descobrir qual tecnologia é ideal para sua casa ou empresa.',
    content: `
      <p>A escolha entre <strong>câmeras IP</strong> e <strong>câmeras analógicas</strong> é uma das decisões mais importantes na hora de montar um sistema de <strong>vídeo monitoramento</strong>. Cada tecnologia tem suas vantagens e é indicada para diferentes cenários.</p>
      <h2>Câmeras IP: tecnologia de ponta</h2>
      <p>As <strong>câmeras IP</strong> oferecem resolução Full HD e 4K, acesso remoto via smartphone, integração com sistemas de alarme e gravação em nuvem. São ideais para quem busca qualidade de imagem e controle total à distância.</p>
      <h2>Câmeras analógicas: custo acessível</h2>
      <p>As <strong>câmeras analógicas</strong> (incluindo as tecnologias HD-TVI e HD-CVI) ainda são uma excelente opção para quem busca um sistema funcional com investimento menor. A instalação é simples e a manutenção é barata.</p>
      <h2>Qual escolher?</h2>
      <p>Se você precisa de alta definição, acesso remoto e integração com outros sistemas, as <strong>câmeras IP</strong> são a melhor escolha. Para orçamentos mais enxutos com necessidades básicas de monitoramento, as analógicas ainda atendem muito bem.</p>
      <h2>Dica da Eletrônica 2000</h2>
      <p>Independentemente da tecnologia escolhida, o posicionamento das câmeras é fundamental. Garanta ângulos que cubram todas as entradas, evite contraluz e mantenha as lentes limpas. Contrate uma empresa especializada para o projeto.</p>
    `,
    categoryId: 'cat-2',
    image: '/imagem/cameras-seguranca.webp',
    imageAlt: '',
    metaTitle: 'Câmeras de Segurança IP vs Analógica | Eletrônica 2000',
    metaDescription: 'Compare câmeras IP e analógicas. Saiba qual tecnologia é ideal para sua casa ou empresa com a orientação da Eletrônica 2000.',
    keywords: 'câmeras de segurança, câmeras IP, vídeo monitoramento, segurança eletrônica',
    mainKeyword: '',
    status: 'published',
    readTime: 5,
    views: 0,
    autoLinkEnabled: true,
    autoLinkLimit: 2,
    authorName: 'Equipe Eletrônica 2000',
    whatsappCTA: false,
    createdAt: '2025-03-28T14:30:00Z',
    updatedAt: '2025-03-28T14:30:00Z',
  },
  {
    id: 'post-3',
    title: 'Portão Eletrônico: 5 Sinais de Que Precisa de Manutenção Urgente',
    slug: 'portao-eletronico-sinais-manutencao',
    excerpt: 'Identifique os 5 principais sinais de que seu portão eletrônico precisa de manutenção urgente.',
    content: `
      <p>O <strong>portão eletrônico</strong> é um equipamento de uso diário que sofre desgaste natural. Identificar os sinais de problemas antes que se tornem falhas graves pode evitar prejuízos e garantir a <strong>segurança da sua família</strong>.</p>
      <h2>1. Barulhos estranhos</h2>
      <p>Ruídos de atrito, rangidos ou batidas durante a abertura/fechamento indicam desgaste de engrenagens, falta de lubrificação ou problemas no motor. Não ignore esses sons.</p>
      <h2>2. Movimento lento ou travado</h2>
      <p>Se o portão está mais lento que o normal ou trava no meio do caminho, pode haver problema no capacitor, motor enfraquecido ou obstrução mecânica nos trilhos.</p>
      <h2>3. Controle remoto falhando</h2>
      <p>Intermitência no sinal do controle pode indicar problema na central de comando, antena ou interferência eletromagnética. Às vezes a solução é simples, mas pode exigir troca de peças.</p>
      <h2>4. Portão não fecha completamente</h2>
      <p>Quando o portão não fecha até o fim, o sensor de fim de curso pode estar desregulado ou danificado. Isso compromete a segurança, pois deixa a propriedade vulnerável.</p>
      <h2>5. Faíscas ou cheiro de queimado</h2>
      <p>Qualquer sinal de curto-circuito exige desligamento imediato e chamada de um técnico. Riscos de incêndio são reais e perigosos.</p>
      <h2>Manutenção preventiva é o segredo</h2>
      <p>Agende uma revisão semestral com a <strong>Eletrônica 2000</strong>. Nossos técnicos fazem inspeção completa do motor, central, sensores e parte mecânica, garantindo anos de funcionamento tranquilo.</p>
    `,
    categoryId: 'cat-3',
    image: '/imagem/portao-eletronico.webp',
    imageAlt: '',
    metaTitle: '5 Sinais de Que Seu Portão Precisa de Manutenção | Eletrônica 2000',
    metaDescription: 'Descubra os principais sinais de problemas no portão eletrônico e como a manutenção preventiva pode evitar prejuízos.',
    keywords: 'portão eletrônico, manutenção portão, motor de portão, segurança residencial',
    mainKeyword: '',
    status: 'published',
    readTime: 5,
    views: 0,
    autoLinkEnabled: true,
    autoLinkLimit: 2,
    authorName: 'Equipe Eletrônica 2000',
    whatsappCTA: false,
    createdAt: '2025-04-02T09:15:00Z',
    updatedAt: '2025-04-02T09:15:00Z',
  },
  {
    id: 'post-4',
    title: 'Alarme Residencial: Como Proteger sua Casa Contra Invasões',
    slug: 'alarme-residencial-proteger-casa',
    excerpt: 'Saiba como funciona um alarme residencial completo e como proteger sua família 24 horas por dia.',
    content: `
      <p>O <strong>alarme residencial</strong> é a peça central de qualquer sistema de <strong>segurança eletrônica</strong> moderno. Com sensores de presença, abertura, fumaça e até câmeras integradas, ele oferece proteção completa 24 horas por dia.</p>
      <h2>Componentes essenciais de um alarme</h2>
      <p>Um sistema completo inclui:</p>
      <ul>
        <li><strong>Central de alarme</strong> – cérebro do sistema, processa todos os sinais</li>
        <li><strong>Sensores de presença</strong> – detectam movimento em ambientes internos</li>
        <li><strong>Sensores magnéticos</strong> – monitoram portas e janelas</li>
        <li><strong>Sensor de fumaça</strong> – alerta em caso de incêndio</li>
        <li><strong>Sirene</strong> – emite som de alerta alto e contínuo</li>
        <li><strong>Discadora/APP</strong> – envia notificações para o celular</li>
      </ul>
      <h2>Monitoramento 24h ou autônomo?</h2>
      <p>O alarme com <strong>monitoramento 24 horas</strong> envia alertas para uma central que aciona a polícia em segundos. Já o sistema autônomo notifica apenas o proprietário via aplicativo. A escolha depende do nível de segurança desejado.</p>
      <h2>Dicas de instalação</h2>
      <p>Instale sensores de presença em pontos estratégicos, evitando ângulos mortos. Posicione a central em local escondido e protegido. Teste o sistema semanalmente e troque as baterias dos sensores a cada 2 anos.</p>
      <h2>Eletrônica 2000: segurança que funciona</h2>
      <p>Nossos projetos de <strong>alarme residencial</strong> são personalizados para cada imóvel. Fazemos vistoria técnica gratuita e apresentamos a melhor solução com preço justo.</p>
    `,
    categoryId: 'cat-4',
    image: '/imagem/alarme-residencial.webp',
    imageAlt: '',
    metaTitle: 'Alarme Residencial: Guia Completo de Proteção | Eletrônica 2000',
    metaDescription: 'Saiba como funciona um alarme residencial completo, quais componentes escolher e como proteger sua família com a Eletrônica 2000.',
    keywords: 'alarme residencial, segurança casa, monitoramento 24h, sensores',
    mainKeyword: '',
    status: 'published',
    readTime: 7,
    views: 0,
    autoLinkEnabled: true,
    autoLinkLimit: 2,
    authorName: 'Equipe Eletrônica 2000',
    whatsappCTA: false,
    createdAt: '2025-03-10T11:00:00Z',
    updatedAt: '2025-03-10T11:00:00Z',
  },
  {
    id: 'post-5',
    title: 'Segurança Rural: Proteja sua Fazenda com Tecnologia',
    slug: 'seguranca-rural-proteger-fazenda',
    excerpt: 'Conheça as melhores soluções de segurança eletrônica para fazendas e propriedades rurais.',
    content: `
      <p>A <strong>segurança rural</strong> é um desafio especial. Propriedades grandes, acesso remoto e limitações de infraestrutura exigem soluções tecnológicas adaptadas. Felizmente, hoje existem equipamentos de <strong>segurança eletrônica</strong> projetados exatamente para esse cenário.</p>
      <h2>Desafios da segurança no campo</h2>
      <p>Fazendas e sítios enfrentam:</p>
      <ul>
        <li>Grandes perímetros difíceis de vigiar</li>
        <li>Falta de energia elétrica em algumas áreas</li>
        <li>Distância dos centros urbanos e demora da polícia</li>
        <li>Furtos de equipamentos, gado e insumos</li>
      </ul>
      <h2>Soluções para propriedades rurais</h2>
      <p>A <strong>Eletrônica 2000</strong> recomenda um conjunto integrado:</p>
      <ul>
        <li><strong>Cerca elétrica solar</strong> – funciona sem rede elétrica, ideal para limites da propriedade</li>
        <li><strong>Câmeras 4G</strong> – transmissão via chip de celular, sem depender de internet fixa</li>
        <li><strong>Alarme com discadora GSM</strong> – liga diretamente para o celular do proprietário</li>
        <li><strong>Cercas virtuais com sensores</strong> – detectam aproximação em áreas estratégicas</li>
      </ul>
      <h2>Câmeras com energia solar e 4G</h2>
      <p>A tecnologia mais revolucionária para o campo são as <strong>câmeras solares com conectividade 4G</strong>. Alimentadas por painéis solares e conectadas via chip de dados, elas transmitem imagens em tempo real para qualquer lugar do mundo.</p>
      <h2>Projeto sob medida</h2>
      <p>Cada propriedade rural é única. Nossos engenheiros visitam o local, mapeiam os riscos e projetam um sistema que combine proteção efetiva com custo viável. Solicite uma vistoria sem compromisso.</p>
    `,
    categoryId: 'cat-5',
    image: '/imagem/seguranca-rural.webp',
    imageAlt: '',
    metaTitle: 'Segurança Rural: Proteja sua Fazenda | Eletrônica 2000',
    metaDescription: 'Conheça as melhores soluções de segurança eletrônica para fazendas e sítios. Câmeras 4G, cerca solar e alarmes rurais.',
    keywords: 'segurança rural, câmeras solar, fazenda proteção, segurança eletrônica rural',
    mainKeyword: '',
    status: 'published',
    readTime: 6,
    views: 0,
    autoLinkEnabled: true,
    autoLinkLimit: 2,
    authorName: 'Equipe Eletrônica 2000',
    whatsappCTA: false,
    createdAt: '2025-04-20T08:45:00Z',
    updatedAt: '2025-04-20T08:45:00Z',
  },
  {
    id: 'post-6',
    title: 'Inteligência Artificial em Câmeras de Segurança: O Futuro da Proteção',
    slug: 'ia-cameras-seguranca-futuro',
    excerpt: 'Descubra como a inteligência artificial está transformando as câmeras de segurança modernas.',
    content: `
      <p>A <strong>inteligência artificial</strong> está revolucionando o mercado de <strong>câmeras de segurança</strong>. Hoje, já existem equipamentos capazes de reconhecer pessoas, detectar comportamentos suspeitos e enviar alertas inteligentes – tudo automaticamente.</p>
      <h2>Reconhecimento facial avançado</h2>
      <p>Câmeras com IA conseguem identificar rostos conhecidos e alertar quando um desconhecido entra na propriedade. Isso elimina alarmes falsos causados por animais ou sombras.</p>
      <h2>Detecção de comportamento</h2>
      <p>Sistemas modernos conseguem detectar padrões como: pessoa circulando em um carro, tentativa de escalada em muros, ou objetos abandonados em áreas restritas.</p>
      <h2>Busca inteligente em vídeos</h2>
      <p>Em vez de rever horas de gravação, basta buscar por "pessoa de camisa vermelha" ou "carro prata" e a IA encontra os momentos automaticamente.</p>
      <h2>Ainda vale a pena investir?</h2>
      <p>Definitivamente sim. A IA está tornando a <strong>segurança eletrônica</strong> mais eficiente e acessível. A Eletrônica 2000 já trabalha com as principais marcas do mercado e pode indicar a melhor solução para seu orçamento.</p>
    `,
    categoryId: 'cat-2',
    image: '/imagem/cameras-ia.webp',
    imageAlt: '',
    metaTitle: 'IA em Câmeras de Segurança: O Futuro | Eletrônica 2000',
    metaDescription: 'Descubra como a inteligência artificial está transformando as câmeras de segurança. Reconhecimento facial, detecção de comportamento e mais.',
    keywords: 'inteligência artificial câmeras, reconhecimento facial, segurança eletrônica, IA',
    mainKeyword: '',
    status: 'published',
    readTime: 5,
    views: 0,
    autoLinkEnabled: true,
    autoLinkLimit: 2,
    authorName: 'Equipe Eletrônica 2000',
    whatsappCTA: false,
    createdAt: '2025-04-25T16:00:00Z',
    updatedAt: '2025-04-25T16:00:00Z',
  },
];

export function getPostBySlug(slug: string): Post | undefined {
  return posts.find((p) => p.slug === slug);
}

export function getPostsByCategory(slug: string): Post[] {
  const cat = categories.find((c) => c.slug === slug);
  if (!cat) return [];
  return posts.filter((p) => p.categoryId === cat.id && p.status === 'published');
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getCategoryNameById(id: string): string {
  const cat = categories.find((c) => c.id === id);
  return cat ? cat.name : 'Geral';
}

export function getPublishedPosts(): Post[] {
  return posts.filter((p) => p.status === 'published');
}

/**
 * Returns a smart mix of related posts:
 * - 1-2 from the same category (most recent)
 * - remaining from other categories (diversified, one per category first)
 * - excludes the current post
 * - total: 4-6 posts (default 6)
 */
export function getMixedRelatedPosts(
  allPosts: Post[],
  currentPostId: string,
  currentCategoryId: string,
  targetCount: number = 6
): Post[] {
  const eligible = allPosts.filter(
    (p) => p.id !== currentPostId && p.status === 'published'
  );

  // Same category — up to 2 most recent
  const sameCat = eligible
    .filter((p) => p.categoryId === currentCategoryId)
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 2);

  // Other categories — diversify first
  const otherCat = eligible
    .filter((p) => p.categoryId !== currentCategoryId)
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  const selectedOthers: Post[] = [];
  const usedCatIds = new Set<string>();

  // Round 1: one post from each different category
  for (const post of otherCat) {
    if (selectedOthers.length >= targetCount - sameCat.length) break;
    if (!usedCatIds.has(post.categoryId)) {
      selectedOthers.push(post);
      usedCatIds.add(post.categoryId);
    }
  }

  // Round 2: fill remaining slots with most recent from any other category
  for (const post of otherCat) {
    if (selectedOthers.length >= targetCount - sameCat.length) break;
    if (!selectedOthers.find((p) => p.id === post.id)) {
      selectedOthers.push(post);
    }
  }

  const result = [...sameCat, ...selectedOthers];
  return result.slice(0, targetCount);
}